export enum UiStorageKey {
  SUBSCRIPTION_RENEWAL = 'subscription-renewal',
  USER_PREFERENCES = 'user-preferences'
}
